import { ArtigoRelacionado } from './../../classes/artigo-relacionado';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuxService } from '../aux.service';

@Component({
  selector: 'app-more-articles',
  templateUrl: './more-articles.component.html',
  styleUrls: ['./more-articles.component.css'],
  standalone: false,
})
export class MoreArticlesComponent {
  constructor(
    private router: Router,
    private aux: AuxService,
  ) {}

  @Input() moreArticles: ArtigoRelacionado[];

  redirectArticle(article, category) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([
        'category/' + this.aux.slugify(category) + '/article/' + article,
      ]);
    });
  }
}
